import { I18n } from '@calendly/i18n'
import { IconX } from '@calendly/ui/components/glyphs/IconX'
import { IconButton } from '@calendly/ui/components/icon-button'

export const MeetingDetailCloseButton = ({ onClick, ...props }) => (
  <IconButton
    title={I18n.t('publisher.action.close')}
    onClick={onClick}
    data-calendly-label="meeting-detail-close"
    icon={IconX}
    {...props}
  />
)
